import type { SelectItem } from '@vrplatform/components';
import type { RequestQuery, ResponseData } from '@vrplatform/data';
import { hasValue, type Maybe } from '@vrplatform/utils';
import { Box, Group, Text } from '@mantine/core';
import { Tooltip } from '@mantine/core';

export const DEFAULT_LISTINGS_FILTER_LIMIT = 50;

type ListingOptionSource = ResponseData<'get:/listings'>['data'][number];

export function getListingsFilterQuery({
  page,
  search,
  ownerIds,
}: {
  page: number;
  search?: string;
  ownerIds?: Maybe<string[]>;
}): RequestQuery<'get:/listings'> {
  const normalizedOwnerIds = ownerIds?.filter(hasValue);
  const isNotActiveOwnership = normalizedOwnerIds?.[0] === 'unmapped';

  return {
    limit: DEFAULT_LISTINGS_FILTER_LIMIT,
    page,
    search: search?.trim() || undefined,
    contactId: isNotActiveOwnership ? undefined : normalizedOwnerIds?.join(','),
    activeOwnership: isNotActiveOwnership ? false : undefined,
  };
}

export function getListingSelectLabel(listing: ListingOptionSource) {
  const label =
    listing.name?.trim() ||
    listing.uniqueRef?.trim() ||
    listing.shortRef?.trim() ||
    'No name';

  if (listing.status === 'inactive') {
    return (
      <Group w="100%" justify="space-between" wrap="nowrap">
        <Text>{label}</Text>
        <Tooltip label="This listing is disabled or has not been assigned an ownership yet">
          <Box
            sx={(theme) => ({
              width: 8,
              height: 8,
              backgroundColor: theme.colors.yellow[6],
              borderRadius: '50%',
              flexShrink: 0,
            })}
          />
        </Tooltip>
      </Group>
    ) as any;
  }

  return label;
}

export function mapListingToSelectItem(
  listing: ListingOptionSource
): SelectItem {
  return {
    value: listing.id,
    label: getListingSelectLabel(listing),
  };
}
